import { render, staticRenderFns } from "./decision-group.vue?vue&type=template&id=c5975036"
import script from "./decision-group.vue?vue&type=script&lang=ts"
export * from "./decision-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5975036')) {
      api.createRecord('c5975036', component.options)
    } else {
      api.reload('c5975036', component.options)
    }
    module.hot.accept("./decision-group.vue?vue&type=template&id=c5975036", function () {
      api.rerender('c5975036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/decision-model/decision-group.vue"
export default component.exports